<template>
  <div>
    <div class="contents" v-for="(tx, index) in txList" :key="index">
      <h1>Transaction {{ index + 1 }}</h1>

      <div class="contents__detail-box">
        <div class="contents__detail-table contents__tx-detail-table">
          <div class="row">
            <span class="field">TRANSACTION HASH</span>
            <span class="value">{{ tx.tx_hash }}</span>
          </div>

          <div class="row">
            <span class="field">
              TIME(UTC +0)
              <FieldNotice :text="TIME_TX_DETAIL_TOOLTIP" />
            </span>
            <span class="value">{{ tx.tx_created_time }}</span>
          </div>

          <div class="row">
            <span class="field">CHAINCODE NAME</span>
            <span class="value">{{ tx.chaincode_name }}</span>
          </div>

          <div class="row">
            <span class="field">FUNCTION NAME</span>
            <span class="value">{{ tx.function_name }}</span>
          </div>

          <div class="row">
            <span class="field">VALIDATION CODE</span>
            <span class="value">{{ tx.validation_code }}</span>
          </div>

          <div class="row" v-if="tx.amount && tx.from_address && tx.to_address">
            <span class="field">FROM ADDRESS</span>
            <span class="value">{{ tx.from_address }}</span>
          </div>

          <div class="row" v-if="tx.amount && tx.from_address && tx.to_address">
            <span class="field">TO ADDRESS</span>
            <span class="value">{{ tx.to_address }}</span>
          </div>

          <div class="row" v-if="tx.amount && tx.from_address && tx.to_address">
            <span class="field">AMOUNT</span>
            <span class="value">{{ tx.amount }} PCI</span>
          </div>

          <div class="row" v-if="tx.function_name === 'token/burn'">
            <span class="field">ADDRESS</span>
            <span class="value">PCI02284DC24C47E270D37EB98B440C943ACE08604A88411A203A</span>
          </div>

          <div class="row">
            <span class="field">BLOCK NUMBER</span>
            <span class="value">
              <router-link class="link" :to="`/blocks/${tx.block_number}`">
                {{ tx.block_number ? tx.block_number.toLocaleString() : 'N/A' }}
              </router-link>
            </span>
          </div>

          <div class="row">
            <span class="field">PAYLOAD PROPOSAL HASH</span>
            <span class="value">{{ tx.payload_proposal_hash }}</span>
          </div>
        </div>
      </div>

      <div class="contents__detail-json-wrap" v-if="tx.payload && isJson(tx.payload)">
        <span class="title">PAYLOAD</span>
        <br />
        <vue-json-pretty
          class="content"
          :data="JSON.parse(tx.payload)"
          highlightMouseoverNode="true"
          showLength="true"
          :deep="Infinity"
        />
      </div>

      <div class="contents__detail-json-wrap" v-if="tx.write_set && isJson(tx.write_set)">
        <span class="title">WRITE SET</span>
        <br />
        <vue-json-pretty
          class="content"
          :data="JSON.parse(tx.write_set)"
          highlightMouseoverNode="true"
          showLength="true"
          :deep="Infinity"
        />
      </div>
    </div>
  </div>
</template>

<script>
import callAPI from "../../api/http";
import err from "../../js/error";
import VueJsonPretty from "vue-json-pretty";
import { convertAttrFormat } from "../../js/format";
import { TIME_TX_DETAIL_TOOLTIP } from "../../js/fields";
import FieldNotice from "./shared/FieldNotice.vue";
import { styleNav } from "../../js/style";

export default {
  name: "TransactionDetail",

  props: ["id"],

  components: {
    VueJsonPretty,
    FieldNotice,
  },

  async beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    await this.getTxDetail();
    next();
  },

  async created() {
    await this.getTxDetail();
  },

  mounted() {
    styleNav(3);
  },

  data() {
    return {
      TIME_TX_DETAIL_TOOLTIP,
      txList: [],
    };
  },

  methods: {
    isJson(str) {
      try {
        JSON.parse(str);
        return true;
      } catch {
        return false;
      }
    },

    async getTxDetail() {
      const id = this.id;

      const { data, errCode } = await callAPI("getTxDetail", id); 

      if (errCode) {
        err(errCode, id, this.$router);
        return;
      }
      const normalizedData = Array.isArray(data) ? data : [data];
      this.txList = normalizedData.map((item) => {
        const formatted = convertAttrFormat(this.$options.name, item);
        return JSON.parse(JSON.stringify(formatted)); 
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/common";

.contents {
  &__tx-detail-table {
    @include detailTableFieldWidth(190px);
  }

  &__detail-json-wrap {
    display: flex;
    flex-direction: column;
    padding: 15px 20px;
    margin-bottom: 10px;
    border: 1px solid #eee;
    background-color: #fff;
    .title {
      font-size: 12px;
      font-weight: 700;
    }
    .content {
      position: static;
      margin-bottom: 0;
      font-size: 13px;
      word-wrap: break-word;
      overflow-x: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contents/TransactionDetail.vue